import React from 'react'
import PropTypes from 'prop-types'
import { Link as RouterLink } from 'react-router'
import { css } from 'aphrodite'
import createStyles from './styles'

export class Link extends React.PureComponent {
  render() {
    const styles = getStyles(this.props, this.context)

    return (
      <RouterLink
        {...this.props}
        className={css(styles.root, this.props.className)}
      >
        {this.props.children}
      </RouterLink>
    )
  }
}

Link.contextTypes = {
  theme: PropTypes.object,
}

const getStyles = createStyles(
  ({ color = 'primary', ...props }, context, theme) => ({
    root: {
      color: theme.colors[color],
      cursor: 'pointer',

      ':hover': {
        textDecoration: 'underline',
      },
    },
  })
)



// WEBPACK FOOTER //
// ./src/components/Link.js